export default "__VITE_ASSET__CzOQH96s__"